import { useState } from 'react'
import PropTypes from 'prop-types'

export const SwitchInput = ({ value, onChange, disabled = false }) => {
    const [myValue, setMyValue] = useState(!!value);

    return (
        <div className="flex items-center mt-2 w-full">
            <label className="flex items-center cursor-pointer">
                <span className="mr-2 text-gray-700 dark:text-gray-300">
                    {myValue ? 'On' : 'Off'}
                </span>
                <div className="relative">
                    <input
                        type="checkbox"
                        className={`sr-only`}
                        checked={myValue}
                        onChange={(event) => {
                            setMyValue(event.target.checked);
                            onChange(event.target.checked);
                        }}
                        disabled={disabled}
                    />
                    <div
                        className={`block w-14 h-8 bg-gray-200 rounded-full transition-colors duration-300 ease-in-out ${myValue ? 'bg-blue-500' : 'bg-gray-300'} ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                    >
                        <div
                            className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${myValue ? 'translate-x-6' : ''}`}
                        />
                    </div>
                </div>
            </label>
        </div>
    );
};

SwitchInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
}
